(function () {
  // Which headings to include
  const HEADING_SELECTOR = "h2, h3";

  function getArticleBody() {
    // Broadcast uses .rte in article content; keep a few fallbacks
    return document.querySelector(
      '[data-article-body], .article__content .rte, .article .rte, .rte--article, .rte'
    );
  }

  function currentHeaderOffset() {
    // Try to estimate sticky/fixed header height (Broadcast header is sticky)
    const el =
      document.querySelector('header') ||
      document.querySelector('.site-header') ||
      document.querySelector('[data-header]');
    return el ? Math.ceil(el.getBoundingClientRect().height) : 0;
  }

  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[\s\._/]+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-+/g, "-")
      .replace(/^\-+|\-+$/g, "");
  }

  function ensureUniqueId(base, taken) {
    let id = base || "section";
    let i = 2;
    while (taken.has(id) || document.getElementById(id)) {
      id = `${base}-${i++}`;
    }
    taken.add(id);
    return id;
  }

  function buildTOC(items) {
    const listHost = document.getElementById("article-toc-list");
    const tocRoot = document.getElementById("article-toc");
    if (!listHost || !tocRoot) return;

    const ul = document.createElement("ul");
    ul.className = "article-toc__list";

    let currentH2Li = null;
    let subUl = null;

    items.forEach(({ el, level }) => {
      const a = document.createElement("a");
      a.textContent = el.textContent.trim();
      a.href = `#${el.id}`;
      a.className = "article-toc__link";
      a.addEventListener("click", (e) => {
        e.preventDefault();
        const target = document.getElementById(el.id);
        if (!target) return;
        const offset = currentHeaderOffset() + 12; // small breathing room
        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.history.pushState(null, "", `#${el.id}`);
        window.scrollTo({ top, behavior: "smooth" });
      });

      if (level === 2) {
        const li = document.createElement("li");
        li.className = "article-toc__item article-toc__item--h2";
        li.appendChild(a);
        ul.appendChild(li);
        currentH2Li = li;
        subUl = null;
      } else if (level === 3) {
        if (!currentH2Li) {
          const li = document.createElement("li");
          li.className = "article-toc__item article-toc__item--h2";
          ul.appendChild(li);
          currentH2Li = li;
          subUl = null;
        }
        if (!subUl) {
          subUl = document.createElement("ul");
          subUl.className = "article-toc__sublist";
          currentH2Li.appendChild(subUl);
        }
        const subLi = document.createElement("li");
        subLi.className = "article-toc__item article-toc__item--h3";
        subLi.appendChild(a);
        subUl.appendChild(subLi);
      }
    });

    if (!ul.children.length) return;

    listHost.innerHTML = "";
    listHost.appendChild(ul);
    tocRoot.hidden = false;

    // Respect hash on first load with header offset
    if (location.hash.length > 1) {
      const target = document.getElementById(location.hash.slice(1));
      if (target) {
        setTimeout(() => {
          const offset = currentHeaderOffset() + 12;
          const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top });
        }, 0);
      }
    }
  }

  function initTOC() {
    const body = getArticleBody();
    if (!body) return;

    const heads = Array.from(body.querySelectorAll(HEADING_SELECTOR));
    const taken = new Set();
    const items = [];

    heads.forEach((el) => {
      const level = Number(el.tagName.replace("H", ""));
      if (![2, 3].includes(level)) return;

      if (!el.id || !el.id.trim()) {
        el.id = slugify(el.textContent || "");
      }
      el.id = ensureUniqueId(el.id, taken);

      // Improve default jump target for CSS-only scrolling
      el.style.scrollMarginTop = (currentHeaderOffset() + 12) + "px";

      items.push({ el, level });
    });

    if (items.length < 2) return; // don’t show TOC for super-short posts
    buildTOC(items);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTOC);
  } else {
    initTOC();
  }
})();
